<div class="flex justify-between md:min-w-[53.25rem]">
  <h2 class="pb-[1rem]">{{ 'feedback.title' | transloco }}</h2>
  @if(userStore.isUserLoggedIn() && userStore.getUserPermission() !==
  UserPermission.User) {<app-button
    [text]="'feedback.ctaDownloadText' | transloco"
    [variant]="'secondary'"
    [icon]="'arrow-down'"
    (buttonClick)="downloadFeedbacks()"
  ></app-button>
  }
</div>
<div class="flex items-end">
  <div
    class="flex flex-col gap-[1.5rem] p-[2.5rem] md:min-w-[53.25rem] h-fit bg-white rounded-3xl mb-[2.5rem]"
  >
    <h4>{{ 'feedback.question' | transloco }}</h4>
    <div class="flex flex-col">
      <p>
        <span>{{ 'feedback.rateYourExperience' | transloco }}</span
        ><span class="italic text-xs">
          {{ 'feedback.mandatoryField' | transloco}}</span
        >
      </p>
      <div class="flex gap-3 mt-3 mb-[1.5rem]">
        @for (ratingOption of ratingButtons(); track $index) {
        <button
          class="hover:cursor-pointer"
          type="button"
          (click)="setRating(ratingOption)"
          [attr.aria-label]="'Note ' + ratingOption"
        >
          <icon
            [name]="'star'"
            [size]="'1.625rem'"
            [color]="ratingOption <= rating() ? 'text-vinciGolden' : 'text-vinciGrey-200'"
          ></icon>
        </button>
        }
      </div>
    </div>
    <label for="feedback-negative">
      <span> {{ 'feedback.shareNegativeFeedback' | transloco }}</span>
      <span class="italic text-xs">
        {{ 'feedback.optionalField' | transloco}}</span
      >
    </label>
    <textarea
      name="feedbackTextareaNegative"
      id="feedback-negative"
      class="border border-vinciBlue-300 text-vinciGrey-500 rounded-lg px-[1rem] py-[0.5rem] resize-none"
      rows="5"
      placeholder="{{ 'feedback.negativeResponsePlaceholder' | transloco }}"
      required
      [value]="feedbackNegativeText()"
      (input)="onFeedbackNegativeChange($event)"
    ></textarea>
    <label for="feedback-positive">
      <span> {{ 'feedback.sharePositiveFeedback' | transloco }} </span>
      <span class="italic text-xs">
        {{ 'feedback.optionalField' | transloco}}</span
      >
    </label>
    <textarea
      name="feedbackTextareaPositive"
      id="feedback-positive"
      class="border border-vinciBlue-300 text-vinciGrey-500 rounded-lg px-[1rem] py-[0.5rem] resize-none"
      rows="5"
      placeholder="{{ 'feedback.positiveResponsePlaceholder' | transloco }}"
      required
      [value]="feedbackPositiveText()"
      (input)="onFeedbackPositiveChange($event)"
    ></textarea>

    <app-button
      [text]="'feedback.submitButton' | transloco"
      [variant]="'secondary'"
      (buttonClick)="submitFeedback()"
      [disabled]="rating() === 0"
    ></app-button>
  </div>
  <img
    [src]="image()"
    alt="Illustration Feedback"
    class="object-contain mobile-hidden"
  />
</div>

@if (isModalOpen()) {
<app-modal
  [title]="'feedback.modalTitle' | transloco"
  [text]="'feedback.modalText' | transloco"
  [buttonText]="'feedback.modalCtaText' | transloco"
  [showClose]="false"
  (completeModal)="completeModal()"
  (closeModal)="closeModal()"
  [image]="'assets/images/modal/feedback-checked.png'"
></app-modal>
}
